import React, { Fragment } from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { MuiThemeProvider } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { browserHistory } from 'react-router'
import Header from './Header'
import token from '../config/jwt_token'
import Snackbar from '@material-ui/core/Snackbar';
import PreviewAndCalculations from './PreviewAndCalculations'
import { approvePaymentRequest, holdPaymentRequest, rejectPaymentRequest, validateGSTN, validatePaymentRequest } from '../utils/PaymentRequestApiUtils'
const theme = createMuiTheme({
  overrides: {
    MuiListItemText: {
      secondary: {
        textDecoration: 'line-through',
        color: 'red'
      }
    }
  }
});

class Preview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      comment: '',
      snackOpen: false,
      dialogBox: false,
      dialogBoxText: '',
      snackMessage: '',
      approveDialogBox: false,
      approveDialogBoxTitle: '',
      approveddialogBoxText: '',
      isApprove:false,
      tablePageHistory: 0,
      invoice_number_exists :false,
      vendorWaringModal: false,
      holdDialogBox: false,
      holddialogBoxTitle: '',
      holddialogBoxText: '',
      paymentStatus: '',
      comment: '',
      commentErr: false,
      commentErrText: ''
    }
    this.handleClose = this.handleClose.bind(this)
    this.handleBack = this.handleBack.bind(this)
  }
  componentWillMount() {
    if (!token || !this.props.location.state) {
      browserHistory.push('/')
      return
    }
    this.setState({ 
      tablePageHistory: this.props.location.state.pageIndex,
      comment: this.props.location.state.paymentDetails.centralFinanceComments
    })
  }

  HandleComment(event) {
    this.setState({ comment: event.target.value, commentErr: false, commentErrText: '' })
  }
  handleDialogBox(value) {
    if (!this.state.comment) {
      this.setState({ commentErr: true, commentErrText: `Can not ${value} without comment!` })
    }
    else{
      if (value === 'approve') {
        const dialogBoxInfo = { 
          approveddialogBoxText: 'Are you sure, you want to approve this request', 
          approveDialogBox: true, 
          isApprove: true 
        }
        const paymentHoldStatus = this.props.location.state.bill_submission_data ? this.props.location.state.bill_submission_data.paymentHoldAtProcessed : null;

        if(paymentHoldStatus == true || paymentHoldStatus == 1) {
          dialogBoxInfo['approveDialogBoxTitle'] = 'Are you sure, you want to approve this request?';
          dialogBoxInfo.approveddialogBoxText = 'This payment will be put on hold in Processed Payments.';
        }

        this.setState(dialogBoxInfo)
      }
      else {
        this.setState({ 
          approveddialogBoxText: 'Are you sure, you want to reject this request', 
          approveDialogBox: true, 
          isApprove: false 
        })
      }
    }
  }
  handleNo() {
    this.setState({ approveDialogBox: false})
  }
  async handleApprove() {
    this.setState({ approveDialogBox: false})
    let body = JSON.stringify([{
      payment_request_id: this.props.location.state.payment_request_id,
      payment_request_transaction_log_id: this.props.location.state.payment_request_transaction_log_id,
      remarks: this.state.comment
    }])
    approvePaymentRequest(body).then(response => {
      if (response) {
        if (response.status === 'success') {
          this.setState({ dialogBox: true, dialogBoxText: response.message })
        }
        else {
          this.setState({ snackMessage: response.message, snackOpen: true })
        }
      }
    })

  }
  async handleReject() {
    this.setState({ approveDialogBox: false})
    let body = JSON.stringify([{
      payment_request_transaction_log_id: this.props.location.state.payment_request_transaction_log_id,
      action: 'reject',
      remarks: this.state.comment
    }])
    rejectPaymentRequest(body).then(response => {
      if (response) {
        if (response.status === 'success') {
          this.setState({ dialogBox: true, dialogBoxText: response.message })
        }
        else {
          this.setState({ snackMessage: response.message, snackOpen: true })
        }
      }
    })
  }
  handleClose() {
    let pageData = {pageIndex: this.state.tablePageHistory}
    pageData.location = this.props.location.pathname
    browserHistory.push({
      pathname: `/vendor/payment/${this.props.location.state.currentEntity}`,
      state: pageData
    })
   }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleBack() {
    let pageData = {pageIndex: this.state.tablePageHistory}
    pageData.location = this.props.location.pathname
    browserHistory.push({
      pathname: `/vendor/payment/${this.props.location.state.currentEntity}`,
      state: pageData
    })
  }

  validateInvoiceNumbers = async () => {
    if(token.role === 'City Head' && this.props.location.state.paymentDetails.type_of_payment === 'Final Settlement') {
      let invoice_number = this.props.location.state.paymentDetails.invoice_number;
      let vendor_code = this.props.location.state.vendor_code;
      let date_of_invoice = this.props.location.state.paymentDetails.date_of_invoice ? new Date(this.props.location.state.paymentDetails.date_of_invoice) : null;
      validatePaymentRequest(vendor_code, invoice_number, date_of_invoice)
      .then(response => {
        if (response) {
          if (response.status === 'failure') {
            return {
              flag: true,
              message: response && response.message || 'Invoice Number already approved for this vendor'
            };
          }
          else {
            return {
              flag: false,
              message: response && response.message || 'Invoice Number already approved for this vendor'
            };
          }
        }
      })
      .then((result) => this.invoice_number_handler(result))
    } else {
      let promise;
      let invoice_number = this.props.location.state.paymentDetails.invoice_number;
      let vendor_code = this.props.location.state.vendor_code;
      promise = Promise.resolve(validateGSTN(vendor_code))
     .then(response => {
          if (response.flag) {
              if (response.data[0].gstn_status == "CANCELLED" || response.data[0].gstn_status == "SUSPENDED") {
                  let gstStatus =  {
                      flag: true,
                      message: `GST status is ${response.data[0].gstn_status} for invoice ${invoice_number}`
                  };
                  this.invoice_number_handler(gstStatus);
              } else {
                this.invoice_number_handler({flag: false});
              }
          }
      })
  }
  }
    

  invoice_number_handler(data) {
    if(data.flag)
      this.setState({invoice_number_exists : data.flag, snackOpen: data.flag, snackMessage: data.message})
    else 
      this.handleDialogBox('approve')
  }

  openApproveDialogBox = async (status) => {
    this.setState({
      holdDialogBox: true,
      holddialogBoxTitle: `Are you sure you want to ${status == 'hold' ? 'hold' : 'release'} this payment request?`,
      holddialogBoxText: `Please enter the comments for ${status == 'hold' ? 'hold' : 'releas'}ing the payment request`,
      paymentStatus: status
    })
  }

  handleNo = () => {
    this.setState({
      holdDialogBox: false,
      holddialogBoxTitle: '',
      holddialogBoxText: '',
      paymentStatus: '',
      comment: '',
      commentErr: false,
      commentErrText: ''
    })
  };

  handleYes = async () => {
    const { comment } = this.state;
    if (comment === undefined || comment === '') {
      this.setState({ commentErr: true, commentErrText: 'Please enter the comments' });
      return;
    };

    const payload = {
      paymentRequestId: this.props.location.state.payment_request_id,
      status: this.state.paymentStatus ? this.state.paymentStatus : 'pending',
      reason: comment,
    }
    this.handleNo();
    const response = await holdPaymentRequest(payload);

    this.setState({ 
      dialogBox: true, 
      dialogBoxText: response.message,
      comment: '',
      commentErr: false,
      commentErrText: ''
    });
  }

  handleComment = (event) => {
    this.setState({ comment: event.target.value });
  }

  clearErr = () => {
      this.setState({commentErr: false, commentErrText: ''})
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Header />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Paper style={{ width: '95%', height: 'auto', marginTop: '20px' }} elevation={1}>
            <div style={{ marginLeft: '68px', marginBottom: '30px' }}>
              <PreviewAndCalculations previewData={this.props.location.state} />
              <div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <TextField
                    onChange={this.HandleComment.bind(this)}
                    defaultValue={this.state.comment}
                    disabled={this.props.params.entity === 'approved'}
                    label="Comments"
                    placeholder="Comments"
                    margin='normal'
                    style={{ width: '520px' }}
                    helperText={this.state.commentErrText}
                    error={this.state.commentErr}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {this.props.params.entity === 'approve' && <Button variant="contained" size="large" style={{ marginTop: '30px', backgroundColor: 'rgb(121,183,79)', color: 'white' }} onClick={this.validateInvoiceNumbers.bind(this)}>
                    Approve
                  </Button>}
                  {this.props.params.entity !== 'approved' && (
                    <Fragment>
                      <Button 
                        variant="contained" 
                        size="large" 
                        style={{ 
                          marginTop: '30px', 
                          marginLeft: '12px', 
                          backgroundColor: 'rgb(220,20,60)', 
                          color: 'white' 
                        }} 
                        onClick={this.handleDialogBox.bind(this, 'reject')}
                      >
                        Reject
                      </Button>
                    </Fragment>
                  )}
                  <Button variant="contained" size="large" color="primary" style={{ marginTop: '30px', marginLeft: '12px' }} onClick={this.handleBack.bind(this)}>
                    Go Back
                  </Button>
                  {/* {((this.props.location.state.paymentDetails.payment_status == 'pending' || this.props.location.state.paymentDetails.payment_status == 'hold' ) && this.props.params.entity == 'pending') && (
                    <Button 
                      size="large" 
                      style={{ 
                        marginTop: '30px', 
                        marginLeft: '12px', 
                        backgroundColor: this.state.inRequest ? 'grey' : 'rgb(255, 165, 0)',
                        color: 'white' 
                      }} 
                      onClick={() => this.openApproveDialogBox(this.props.location.state.paymentDetails.payment_status == 'hold' ? 'pending' : 'hold')}
                    >
                      {this.props.location.state && this.props.location.state.paymentDetails.payment_status == 'hold' ? "Release Payment Request" : "Hold Payment Request"}
                    </Button>
                  )} */}
                  {(this.props.location.state.paymentDetails.payment_status == 'pending' && this.props.params.entity == 'pending') && (
                    <Button 
                      size="large" 
                      style={{ 
                        marginTop: '30px', 
                        marginLeft: '12px', 
                        backgroundColor: this.state.inRequest ? 'grey' : 'rgb(255, 165, 0)',
                        color: 'white' 
                      }} 
                      onClick={() => this.openApproveDialogBox('hold')}
                    >
                      Hold Payment Request
                    </Button>
                  )}
                </div>
              </div>
            </div>

          </Paper>
        </div>
        <Dialog
          open={this.state.approveDialogBox}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {this.state.approveDialogBoxTitle && (
            <DialogTitle id="form-dialog-title">{this.state.approveDialogBoxTitle}</DialogTitle>
          )}
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.approveddialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo.bind(this)} color="primary">
              No
            </Button>
            <Button onClick={this.state.isApprove === true ? this.handleApprove.bind(this) : this.handleReject.bind(this)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.dialogBox}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.dialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.holdDialogBox}
          onClose={this.handleNo}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="form-dialog-title">{this.state.holddialogBoxTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {this.state.holddialogBoxText}
            </DialogContentText>
            <TextField
              autoFocus
              onClick={this.clearErr}
              onChange={this.handleComment}
              helperText={this.state.commentErrText}
              error={this.state.commentErr}
              margin="dense"
              id="comment"
              label="*Comment"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo} color="primary">No</Button>
            <Button onClick={this.handleYes} color="primary" autoFocus>Yes</Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={5000}
          onClose={this.handleCloseSnack.bind(this)}
        />

      </MuiThemeProvider>
    )
  }
}
export default Preview


// WEBPACK FOOTER //
// ./src/components/Preview.js